// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { OptionsTooltip_ReadyPlanOptionFragmentDoc } from './OptionsTooltipContent.generated';
export type RequiredWhenTag_RequiredWhenFragment = { __typename?: 'ReadyPlanOptionGroupRequiredWhen', all: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }>, none: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, code: string, readyPlanLocation?: { __typename?: 'ReadyPlanLocation', id: string, location: { __typename?: 'Location', id: string, displayLocationPath: string } } | null | undefined }> };

export const RequiredWhenTag_RequiredWhenFragmentDoc = gql`
    fragment RequiredWhenTag_RequiredWhen on ReadyPlanOptionGroupRequiredWhen {
  all {
    ...OptionsTooltip_ReadyPlanOption
  }
  none {
    ...OptionsTooltip_ReadyPlanOption
  }
}
    ${OptionsTooltip_ReadyPlanOptionFragmentDoc}`;